import { Block, HeadingSmall, LabelSmall, Mats, useStyletron, } from "@mezo-org/mezo-clay";
import React from "react";
import DefaultAvatar from "../../../assets/DefaultAvatar";
const DOT_DELIMITER_REGEX = /(?=\.)/;
export default function WelcomeBlock(props) {
    const { mezoId, matsBalance } = props;
    const [name, nameSuffix] = mezoId.split(DOT_DELIMITER_REGEX);
    const [, theme] = useStyletron();
    return (React.createElement(Block, { display: "flex", alignItems: "center", padding: `${theme.sizing.scale600} 0`, marginBottom: theme.sizing.scale300, overrides: {
            Block: {
                style: {
                    gap: theme.sizing.scale600,
                },
            },
        } },
        React.createElement(Block, { as: DefaultAvatar, width: theme.sizing.scale1200, height: theme.sizing.scale1200, overrides: {
                Block: {
                    style: {
                        borderRadius: "100%",
                    },
                },
            } }),
        React.createElement(Block, { display: "flex", flexDirection: "column", overrides: {
                Block: {
                    style: {
                        gap: theme.sizing.scale100,
                    },
                },
            } },
            React.createElement(HeadingSmall, { as: "span" },
                React.createElement(Block, { as: "span" }, name),
                React.createElement(Block, { as: "span", color: theme.colors.gray500 }, nameSuffix)),
            React.createElement(LabelSmall, { display: "flex", alignItems: "center", margin: 0, color: theme.colors.contentTertiary, overrides: {
                    Block: {
                        style: {
                            gap: theme.sizing.scale400,
                        },
                    },
                } },
                React.createElement(Mats, { color: theme.colors.contentPrimary, size: theme.sizing.scale500 }),
                matsBalance,
                " mats"))));
}
//# sourceMappingURL=WelcomeBlock.js.map